let unlockedPrivateKey: string | null = null;

export function setUnlockedPrivateKey(pk: string | null): void {
  unlockedPrivateKey = pk;
}

export function getUnlockedPrivateKey(): string | null {
  return unlockedPrivateKey;
}
